<template>
  <div
    :class="{
      'col-md-6 d-flex align-items-stretch': small,
      'col-md-12': !small,
    }"
  >
    <cards class="address-card">
      <div class="wrapper-address-Item" :class="{ mark: item.is_primary }">
        <div class="box details">
          <p class="name" style="color:red">
            {{ item.name ? item.name : "-" }}
          </p>
          <p
            class="address"
            v-html="getHelpers.generateFromatedAddress(item)"
          ></p>
        </div>
        <div class="box is-primary text-center my-auto">
          <div class="btn-group-vertical edit">
            <n-button
              :type="_type"
              icon
              link
              @click="markAsPrimary(item.id)"
              :disabled="item.is_primary"
              :title="$t('title.mark_as_primary_address')"
            >
              <i class="k-icon-ok"></i>
            </n-button>
          </div>
        </div>
        <div class="box edit text-center my-auto">
          <div class="btn-group-vertical remove">
            <n-button type="success" link icon round @click="editAddress(item)">
              <i class="k-icon-edit-profile"></i>
            </n-button>
          </div>
        </div>
        <div class="box remove text-center my-auto">
          <div class="btn-group-vertical remove">
            <n-button
              type="danger"
              link
              icon
              round
              @click="removeAddress(item.id)"
            >
              <i class="k-icon-trash"></i>
            </n-button>
          </div>
        </div>
      </div>
    </cards>
  </div>
</template>
<script>
import {
  Button,
  Cards,
  Checkbox,
} from "@/components";
import { helpers } from "@/utilities";
import { mapActions } from "vuex";
export default {
  name:'address-item',
  components: {
    [Button.name]: Button,
    Cards,
    [Checkbox.name]: Checkbox,
  },
  props: {
    item: {},
    small: Boolean,
  },
  data() {
    return {
      getHelpers: helpers,
    };
  },
  methods: {
    ...mapActions([
      "deleteAddress",
      "updateAddressRequest",
      "primaryAddressRequest",
    ]),
    markAsPrimary(idAddress) {
      let self = this;
      this.primaryAddressRequest(idAddress)
        .then((response) => {
          if (response && response.error) {
              helpers.showErrorMessageAlert(
              helpers.getMessageFromAPIError(response)
            );
            return;
          }

          self.$notify({
            group: "topRight",
            title: this.$t("message.address_marked_notify_title"),
            type: "warn",
            text: this.$t("message.address_marked_notify_message"),
          });
        })
        .catch((e) => {
          this.captureException(e)
          //---- show Notification with error
          self.$notify({
            group: "topRight",
            title: this.$t("message.address_marked_notify_title"),
            type: "danger",
            text: this.$t("message.address_marked_notify_message"),
          });
        });
    },
    removeAddress(idAddress) {
      //--- show confirmation before deleting an address
      let message = this.$t("message.resource_delete_message_confirmation", {resource_name : "address"});
      let self = this;
      let options = {
        html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        okText: this.$t("button.confirm"),
        cancelText: this.$t("button.cancel"),
        animation: "fade", // Available: "zoom", "bounce", "fade"
        type: "basic", // coming soon: 'soft', 'hard'
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
      };

      this.$dialog.confirm(message, options).then(function() {
        self
          .deleteAddress(idAddress)
          .then((response) => {
            if (response && response.error) {
                helpers.showErrorMessageAlert(
                helpers.getMessageFromAPIError(response)
              );
              return;
            }

            self.$notify({
              group: "topRight",
              title: this.$t("message.resource_removed_notify_title", {resource_name : "address"}),
              type: "warn",
              text: this.$t("message.resource_removed_notify_message", {resource_name : "Address"})
            });
          })
          .catch((e) => {
            this.captureException(e)
            //---- show Notification with error
            self.$notify({
              group: "topRight",
              title: this.$t("message.resource_error_notify_title"),
              type: "danger",
              text: this.$t("message.resource_error_remove_notify_message", {resource_name : "address"}),
            });
          });
      });
    },
    editAddress(item) {
      this.$emit("updateUserAddress", item);
    },
  },
  computed: {
    _type() {
      return this.item.is_primary ? "success" : "neutral";
    },
  },
};
</script>
<style scoped>
.form-group.input-group,
.form-group.input-group {
  padding: 0 !important;
}
</style>
